import { render, staticRenderFns } from "./labelDetails.vue?vue&type=template&id=08cdfdef&scoped=true&"
import script from "./labelDetails.vue?vue&type=script&lang=js&"
export * from "./labelDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cdfdef",
  null
  
)

export default component.exports